import { render, staticRenderFns } from "./EodbThirdPartyVerification.vue?vue&type=template&id=e645bd5e&scoped=true&"
import script from "./EodbThirdPartyVerification.vue?vue&type=script&lang=js&"
export * from "./EodbThirdPartyVerification.vue?vue&type=script&lang=js&"
import style0 from "./EodbThirdPartyVerification.vue?vue&type=style&index=0&id=e645bd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e645bd5e",
  null
  
)

export default component.exports